import { Box, Grid } from '@mui/material';
import { EmptyPlaceholder } from 'shared/components/EmptyPlaceholder';
import { TournamentSettingsTitle } from '../../TournamentSettingsTitle';
import { Place } from './Place';
import React, { FC, useMemo } from 'react';
import { TournamentBreakdown } from '@okletsplay/core';
import { useStyles } from './TournamentPrizes.styles';
import { GameCurrency } from 'modules/game-payments/components';
import { TournamentPrizesTitle } from '../../TournamentPrizesTitle';

interface TournamentPrizesProps {
  distributionBreakdown: TournamentBreakdown[];
}

export const TournamentPrizes: FC<TournamentPrizesProps> = ({ distributionBreakdown }) => {
  const { classes } = useStyles();

  const isPaidTournament = useMemo(
    () => distributionBreakdown?.find((breakdown) => breakdown?.amount > 0),
    [distributionBreakdown]
  );

  return (
    <Box className={classes.root}>
      <TournamentSettingsTitle>Prizes</TournamentSettingsTitle>
      <TournamentPrizesTitle />
      {isPaidTournament ? (
        <Grid container spacing={2} className={classes.root}>
          {distributionBreakdown?.map(
            (breakdown) =>
              Boolean(breakdown?.amount) && (
                <Grid xs={12} sm={6} md={4} lg={6} xl={4} item key={breakdown.places.join('-')}>
                  <Box className={classes.place}>
                    <Place places={breakdown.places} />
                    <GameCurrency amount={breakdown.amount} />
                  </Box>
                </Grid>
              )
          )}
        </Grid>
      ) : (
        <EmptyPlaceholder text="Free Tournament!" />
      )}
    </Box>
  );
};
